module.exports = __webpack_public_path__ + "img/multitouch-poster.3cd5775.jpg";